import { withStyles, makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    width: '70%',
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#081194',
  },
}))(LinearProgress);

const useStyles = makeStyles(() => ({
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  itemsCont: {
    margin: '5px',
  },
  title: {
    fontFamily: 'Nunito, sans-serif',
    fontSize: '20px',
    fontWeight: 'Bold',
  },
  barContainer: {
    margin: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  description: {
    fontFamily: 'Nunito, sans-serif',
    fontSize: '14px',
    fontWeight: 'Bold',
  },
}));

export { BorderLinearProgress, useStyles };
